import React, { useState } from "react";
import "./Sidebar.css";

export interface SidebarMenuItem {
    id: string;
    label: string;
    icon?: React.ReactNode;
    disabled?: boolean;
}

interface SidebarProps {
    title: string;
    titleIcon?: React.ReactNode;
    menuItems: SidebarMenuItem[];
    activeItem: string;
    onSelect: (id: string) => void;
}

export default function Sidebar({ title, titleIcon, menuItems, activeItem, onSelect }: SidebarProps) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <aside className={`sidebar-container ${isCollapsed ? "collapsed" : "expanded"}`}>
            <div className="sidebar-header">
                <div className="sidebar-title-area">
                    {titleIcon && <div className="sidebar-title-icon">{titleIcon}</div>}
                    <h2 className="sidebar-title-text">{title}</h2>
                </div>
                <button
                    className="sidebar-toggle-btn"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    title={isCollapsed ? "사이드바 열기" : "사이드바 접기"}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {isCollapsed ? (
                            <>
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </>
                        ) : (
                            <polyline points="15 18 9 12 15 6"></polyline>
                        )}
                    </svg>
                </button>
            </div>
            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        className={`sidebar-nav-item ${activeItem === item.id ? "active" : ""}`}
                        onClick={(e) => {
                            if (item.disabled) {
                                e.preventDefault();
                                return;
                            }
                            onSelect(item.id);
                        }}
                        style={item.disabled ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                        disabled={item.disabled}
                        title={isCollapsed ? item.label : undefined}
                    >
                        {item.icon && <div className="sidebar-nav-icon">{item.icon}</div>}
                        <span className="sidebar-nav-text">{item.label}</span>
                    </button>
                ))}
            </nav>
        </aside>
    );
}
